import React from "react";
import { ManagedStep } from "common/components/StepContainer";
import { useIntl } from "react-intl";
import { transfersShipmentCreateLabels } from "transfers/create/transfersShipmentCreate.labels";
import { TransferProductChooser } from "./components/TransferProductChooser";
import { useTransferUnifiedProductSelectionStep } from "./useTransferUnifiedProductSelectionStep";
import styled from "@emotion/styled";
import { EachPickingToggle } from "./components/EachPickingToogle";
import { InventoryPool } from "@deliverr/business-types";
import { BulkProductUploadReport } from "./components/BulkProductUploadReport";

export const TransferUnifiedProductSelectionStep = () => {
  const { formatMessage } = useIntl();
  const {
    distributionChannel,
    isNextDisabled,
    isNextStepLoading,
    addProduct,
    removeProduct,
    updateQty,
    updateNumberOfCases,
    selectedProducts,
    shouldShowEachPickButton,
    inventoryPool,
    isKittingEnabled,
    shouldShowLotNumberDropdown,
    shouldUseCasePack,
    isEachPickingOrder,
    handleEachPickingToggle,
    updateLotNumber,
    selectedProductsLotNumbersList,
    selectedProductsLotNumbers,
    shouldShowBulkProductUploadReport,
  } = useTransferUnifiedProductSelectionStep();

  // ToDo - Add Estimated pallet count for RS to Ecom transfer
  return (
    <ManagedStep
      title={formatMessage(transfersShipmentCreateLabels.steps.product.title)}
      subtitle={formatMessage(transfersShipmentCreateLabels.steps.product.subtitle)}
      isNextDisabled={isNextDisabled}
      isLoading={isNextStepLoading}
      data-testid="transfer-unified-product-selection-step"
    >
      <ProductSearchContainer>
        {shouldShowEachPickButton && (
          <EachPickingToggle
            isEachPickingOrder={!!isEachPickingOrder}
            handleToggle={handleEachPickingToggle}
            isDisabled={inventoryPool === InventoryPool.DEFAULT}
          />
        )}
        {shouldShowBulkProductUploadReport && <BulkProductUploadReport style={{ marginBottom: "S4" }} />}

        <TransferProductChooser
          addProduct={addProduct}
          removeProduct={removeProduct}
          updateQty={updateQty}
          updateNumberOfCases={updateNumberOfCases}
          selectedProducts={selectedProducts}
          distributionChannel={distributionChannel!}
          shouldUseCasePack={shouldUseCasePack}
          inventoryPool={inventoryPool}
          isKittingEnabled={isKittingEnabled}
          shouldShowLotNumberDropdown={shouldShowLotNumberDropdown}
          updateLotNumber={updateLotNumber}
          selectedProductsLotNumbersList={selectedProductsLotNumbersList}
          selectedProductsLotNumbers={selectedProductsLotNumbers}
        />
      </ProductSearchContainer>
    </ManagedStep>
  );
};

const ProductSearchContainer = styled.div`
  width: 80%;
`;
